{
  "back": "Назад",
  "form": "Форма",
  "purposeTitle": "Какова цель вашей остановки?",
  "appointmentInfoTitle": "Информация о назначении",
  "appointmentInfoHint": "Обязательно заполните это поле, если у вас есть назначение.",
  "checkInDetailsTitle": "Детали регистрации",
  "checkInDetailsHint": "Дополнительная информация о вашем визите.",
  "driverPhoneLabel": "Номер телефона водителя",
  "activateWhatsAppTitle": "Активировать сообщения WhatsApp",
  "activateWhatsAppBody": "Чтобы общаться со складом, ответьте «OK» на первое сообщение WhatsApp от нас.",
  "whatsappDelayBanner": "Первое сообщение WhatsApp может занять до одной минуты.",
  "notesLabel": "Примечания",
  "notesPlaceholder": "Особые инструкции или примечания для объекта?",
  "addNoteToWarehouse": "Добавить заметку для склада",
  "verifyAndCheckIn": "Проверить и зарегистрироваться",
  "completeCheckIn": "Завершить регистрацию",
  "visitGroupInbound": "Входящий",
  "visitGroupOutbound": "Исходящий",
  "visitGroupBoth": "Входящий и исходящий",
  "visitUnloadTruck": "Разгрузить мой грузовик",
  "visitDropTrailer": "Оставить мой прицеп или контейнер",
  "visitLoadTruck": "Загрузить мой грузовик",
  "visitHookTrailer": "Прицепить прицеп или контейнер",
  "visitUnloadLoad": "Разгрузить и загрузить мой грузовик",
  "visitDropHook": "Оставить и прицепить прицеп или контейнер",
  "containerTrailer": "Прицеп",
  "containerContainer": "Контейнер",
  "containerOversized": "Негабаритный",
  "containerOther": "Другое",
  "defaultReferenceName": "Номер заказа на покупку",
  "identifierSuffix": "{reference} или номер подтверждения",
  "licenseOrDotRequired": "Пожалуйста, укажите номерной знак или номер DOT",
  "appointmentNotFound": "Нам не удалось найти вашу запись",
  "referenceNotFound": "Совпадающая запись не найдена. Референс-номера чувствительны к регистру.",
  "referenceCaseSensitiveHint": "Референс-номер чувствителен к регистру",
  "messaging": {
    "whatsappFailedTitle": "Не удалось отправить сообщение WhatsApp",
    "smsFailedTitle": "Не удалось отправить SMS-сообщение",
    "whatsappFailedBody": "Нам не удалось отправить сообщение на номер {displayPhone}. <br /><br /> Если вы ранее отписались, пожалуйста, отправьте START на номер <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a>, чтобы снова получать сообщения от этого склада.",
    "smsFailedBody": "Нам не удалось отправить сообщение на номер {displayPhone}. <br /><br /> Если вы ранее отписались, пожалуйста, отправьте START на номер <a href='{smsUrl}'>{senderPhone}</a>, чтобы снова получать SMS-сообщения от этого склада.",
    "fallbackPhone": "указанный номер телефона"
  }
}
